<template>
  <div>
    <div class="content-heading">
      <i class="ic-head-icon">
        <img
          src="@/assets/images/sidebar/orders.svg"
          alt="Orders"
          class="h-100"
        />
      </i>
      <h4 class="head-title">Orders</h4>
      <i class="ic-tooltip" id="help"></i>
      <b-popover
        target="help"
        triggers="hover"
        content="Process customer orders from different sales channel."
      ></b-popover>
      <AppTabs :tabs="tabs" />
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import AppTabs from "@/components/common/AppTabs.vue";
import permission from "@/services/user.permission";

export default {
    components: {
        AppTabs
    },
    data() {
        return {
            tabs: [
                {
                    name: permission.getSubmoduleName(
                        "estore-orders.orders:topup-estore"
                    ),
                    href: "/orders/list",
                    access: "estore-orders.orders:topup-estore"
                },
                {
                    name: permission.getSubmoduleName(
                        "estore-orders.payment-express:topup-estore"
                    ),
                    href: "/orders/payment-express",
                    access: "estore-orders.payment-express:topup-estore"
                },
                {
                    name: permission.getSubmoduleName(
                        "estore-orders.dine-in:topup-table_ordering"
                    ),
                    href: "/orders/dine-in",
                    access: "estore-orders.dine-in:topup-table_ordering"
                }
            ]
        };
    }
};
</script>
